import React from 'react';
import { __ } from '../../../utils/translation-service';
import { DreamlinesButton } from '../../atoms/dreamlines-button/dreamlines-button';
import { DateTypes, IDates } from '../calendar/calendar';
import Calendar from '../calendar/calendar-modal';
import { Modal } from '../modal/modal';
import { StyledCalendar, StyledSubmitDate } from './calendar-modal.style';
import { CalendarInput } from './input/input';
import { ResetButton } from './reset-button/reset-button';

interface IProps {
    onDateChange?: ({ startDate, endDate }: { startDate?: Date; endDate?: Date }) => void;
    className?: string;
}

// @TODO remove the unwanted previous code once tested properly
export const CalendarModal = (props: IProps) => {
    const [startDate, setStartDate] = React.useState();
    const [endDate, setEndDate] = React.useState();
    // We need a private values to handle custom inputs shown inside the search mask
    const [_startDate, _setStartDate] = React.useState();
    const [_endDate, _setEndDate] = React.useState();
    const [focusedInput, setFocusedInput] = React.useState<DateTypes>();
    const [showModal, setShowModal] = React.useState(false);

    const handleDatesChange = (dates: IDates) => {
        setStartDate(dates.startDate);
        setEndDate(dates.endDate);
    };

    const handleModal = (_clickedInput?: DateTypes) => {
        setShowModal(!showModal);
        setFocusedInput(_clickedInput || null);
    };

    const submitDates = () => {
        handleModal(null);
        _setStartDate(startDate);
        _setEndDate(endDate);
        props.onDateChange && props.onDateChange({ startDate, endDate });
    };

    const resetState = () => {
        handleDatesChange({ startDate: undefined, endDate: undefined });
        props.onDateChange && props.onDateChange({ startDate: undefined, endDate: undefined });
        _setStartDate(undefined);
        _setEndDate(undefined);
    };

    return (
        <div>
            <CalendarInput
                onClick={handleModal}
                startDate={_startDate}
                endDate={_endDate}
                className={props.className}
            />
            {showModal && (
                <Modal
                    showModal={showModal}
                    headerText={__('calendarTravelDate')}
                    onClose={() => handleModal(null)}
                    rightIcon={<ResetButton onClick={() => resetState()} />}
                >
                    <StyledCalendar data-testid="calendar-modal">
                        <Calendar
                            focusedInput={focusedInput}
                            onDateChange={handleDatesChange}
                            startDate={startDate}
                            endDate={endDate}
                            isMobile
                        />
                    </StyledCalendar>
                    {(startDate || endDate) && (
                        <StyledSubmitDate>
                            <DreamlinesButton
                                wrapperStyle={{ width: '100%' }}
                                style={{ width: '100%', height: 60, borderRadius: 0 }}
                                onClick={submitDates}
                            >
                                {__('calendarSubmit')}
                            </DreamlinesButton>
                        </StyledSubmitDate>
                    )}
                </Modal>
            )}
        </div>
    );
};
